export { default as NextImage } from './NextImage';
